import { render } from "./MyTasks.vue?vue&type=template&id=40cc98a6&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"

import "./MyTasks.vue?vue&type=style&index=0&id=40cc98a6&scoped=true&lang=css"
import "./MyTasks.vue?vue&type=style&index=1&id=40cc98a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cc98a6"]])

export default __exports__